import {z} from 'zod'

import {FormValidationInput} from '../../types'
import {ErrorCodes} from '../common/validation/errorCodes'
import {validateFieldRange} from '../common/validation/validateFieldRange'

import {RetarderConfiguration, RetarderForm} from './types'

export const retarderSchema = z.object({
  retarder: z.union([
    z.object({
      retarder: z.number(),
      retarderUom: z.string()
    }),
    z.undefined()
  ])
})

export const validateRetarder = (
  data: RetarderForm,
  ctx: z.RefinementCtx,
  {configuration: {retarder: retarderConfiguration}}: FormValidationInput<RetarderConfiguration>
) => {
  if (!retarderConfiguration.isEnabled) {
    if (data.retarder) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['retarder'],
        message: ErrorCodes.retarder.notAllowed
      })
    }
    return
  }

  if (data.retarder === undefined) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ['retarder'],
      message: ErrorCodes.retarder.required
    })
    return
  }

  validateFieldRange(data.retarder.retarder, retarderConfiguration, 'retarder', 'retarder', ctx)
}
